import React from 'react'

export type ContentProps = React.PropsWithChildren<{}>

export const Content: React.FC<ContentProps> = ({ children }) => (
  <main>{children}</main>
)
